import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
   getContactUsContent, getOfficesFilterList, office , getChiefInformation
} from './actions'
import './Contact.scss';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { getRouting, getIconForFile, formDataGenerator } from '../../../../utils/common';
import 'react-tabs/style/react-tabs.css';
import Slider from 'react-slick';
import { Helmet } from "react-helmet";
import WriteToModal from '../../general/Modals/WriteToModal';
import Select from 'react-select';
import { array } from "prop-types";
import PageNotFound from "../PageNotFound";


const ContactUs = (props) => {

   const { getContactUsContent, getInTouchContent, getVisitUsContent, getInvesterRelationship, getStakeholderContent, getOfficesFilterList, getFilterListCOntent, office, officeAddress,  getChiefInformation, getChiefContent, location: { pathname }, } = props;

   const nodeData = pathname.split("/");
   const current = nodeData[nodeData.length - 1];
   const [getintouchdata, setgetintouchdata] = useState();
   const [getvisitUsdata, setgetvisitUsdata] = useState();
   const [getrelationdata, setgetrelationdata] = useState();
   const [getstakeholderdata, setgetstakeholderdata] = useState();
   const [getfilterListdata, setgetfilterListdata] = useState();
   const [getselectStatelist, setgetselectStatelist] = useState();
   const [getselectStatedata, setgetselectStatedata] = useState();
   const [getchiefdata, setgetchiefdata] = useState();
   const [getselectCitylist, setgetselectCitylist] = useState();
   const [getselectCitydata, setgetselectCitydata] = useState();
   // const [latitude, setlatitude] = useState(18.9295844);
   // const [longitude, setlongitude] = useState(72.8262993);
   const [tabName, setTabName] = useState();
   const [selectedIndex, setSelectedIndex] = useState(0);
   // const currentPageurl = window.location.pathname.split('/')[2];
   const [currentPageurl, setCurrentPageurl] = useState('');
   const [getHeaderBreadCrump, setgetHeaderBreadCrump] = useState('Get In Touch');
   const [hdfcOffice, sethdfcOffice] = useState('');
   const [camsOffice, setcamsOffice] = useState('');
   const [metaData, setmetaData] = useState();
   const [flag , setFlag] = useState(false);

    // console.log("getchiefdata", getchiefdata);

   useEffect(() => {
      if (current) {
         setCurrentPageurl(current);
       }   
   }, [current])

   useEffect(()=>{
      if(flag == true){
        setFlag(false);
      }
    },[flag]);  

   useEffect(() => {
      if (window.location.pathname.split('/')[2] === "get-in-touch") {
         setSelectedIndex(0);
         setgetHeaderBreadCrump('Get In Touch');
         !(getInTouchContent && getInTouchContent.content && flag == false) && getContactUsContent({}, currentPageurl);
      }

      if (window.location.pathname.split('/')[2] === "visit-us") {
         setSelectedIndex(1)
         getOfficesFilterList();
         setgetHeaderBreadCrump('Visit Us');
         !(getVisitUsContent && getVisitUsContent.content && flag == false) && getContactUsContent({}, currentPageurl);
      }

      if (window.location.pathname.split('/')[2] === "investor-relationship-officer") {
         setSelectedIndex(2)
         setgetHeaderBreadCrump('Investor Relationship Officer');
         !(getInvesterRelationship && getInvesterRelationship.content && flag == false) && getContactUsContent({}, currentPageurl);
      }

      if (window.location.pathname.split('/')[2] === "stakeholders-information-and-helpdesk") {
         setSelectedIndex(3)
         setgetHeaderBreadCrump('Stakeholders Information & Helpdesk');
         !(getStakeholderContent && getStakeholderContent.content && flag == false) && getContactUsContent({}, currentPageurl);
      }
      if (currentPageurl === "chief-information-security-officer") {
         setSelectedIndex(4);
         setgetHeaderBreadCrump("Chief Information Security Officer");
         !(getChiefContent && getChiefContent.content && flag == false) && getChiefInformation();
      }
      // getContactUsContent && getContactUsContent({}, currentPageurl);
   }, [currentPageurl])

   // useEffect(() => {
   //    getContactUsContent && getContactUsContent({}, currentPageurl);
   // }, [])

   useEffect(() => {
      if (getInTouchContent && getInTouchContent.content) {
         setgetintouchdata(getInTouchContent)
      }

      if (getInTouchContent && getInTouchContent.tabs) {
         setTabName(getInTouchContent.tabs)
      }
   }, [getInTouchContent])

   useEffect(() => {
      if (getVisitUsContent && getVisitUsContent.content) {
         setgetvisitUsdata(getVisitUsContent.content)
      }

   }, [getVisitUsContent])
   useEffect(() => {
      if (getInvesterRelationship && getInvesterRelationship.content) {
         setgetrelationdata(getInvesterRelationship.content)
      }

   }, [getInvesterRelationship])

   useEffect(() => {
      if (getStakeholderContent && getStakeholderContent.content) {
         setgetstakeholderdata(getStakeholderContent.content)
      }

   }, [getStakeholderContent])

   useEffect(() => {
      if (getChiefContent && getChiefContent.content) {
        setgetchiefdata(getChiefContent.content);
      }

   }, [getChiefContent]);

   useEffect(() => {
      const myStateArray = [];
      if (getFilterListCOntent && getFilterListCOntent.content) {
         setgetfilterListdata(getFilterListCOntent.content);
      }
      if(getFilterListCOntent && getFilterListCOntent.content && getFilterListCOntent.content.state_city_area){
         getFilterListCOntent.content.state_city_area.length > 0 && getFilterListCOntent.content.state_city_area.map((item)=>{
           item.label = item.name;
           item.value = item.id;
           myStateArray.push(item);
         })
         setgetselectStatelist(myStateArray);
      }
 
   }, [getFilterListCOntent])

   // useEffect(() => {
   //    if (officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.ISC && officeAddress.HDFC.data.ISC.locations && officeAddress.HDFC.data.ISC.locations[0] && officeAddress.HDFC.data.ISC.locations[0].latitude) {
   //       setlatitude(officeAddress.HDFC.data.ISC.locations[0].latitude);
   //    }
   //    if (officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.ISC && officeAddress.HDFC.data.ISC.locations && officeAddress.HDFC.data.ISC.locations[0] && officeAddress.HDFC.data.ISC.locations[0].longitude) {
   //       setlongitude(officeAddress.HDFC.data.ISC.locations[0].longitude);
   //    }
   // }, [officeAddress])


   useEffect(() => {
      if (officeAddress && officeAddress.HDFC && officeAddress.HDFC.data) {
         // if(officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.BRANCHES){


         // }else if(officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.ISC){

         // }else if(officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.ISC_POA){

         // }else if(officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.LTP){

         // }else if(officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.POA){

         // }else if(officeAddress && officeAddress.HDFC && officeAddress.HDFC.data && officeAddress.HDFC.data.Business Centre){

         // }
         sethdfcOffice(officeAddress.HDFC.data);

      } else {
         sethdfcOffice('');
      }

      if (officeAddress && officeAddress.CAMS && officeAddress.CAMS.data) {
         setcamsOffice(officeAddress.CAMS.data);
      } else {
         setcamsOffice('');
      }
   }, [officeAddress])


   const handleApiCall = async (e, tabName) => {
      // getContactUsContent && getContactUsContent({}, tabName);
      setCurrentPageurl(tabName);
      setFlag(true);
   };

   const handleChange = (event) => {
      setgetselectCitydata('');
      const myChildArray = [];
      const arrayMap = getfilterListdata && getfilterListdata.state_city_area;

      arrayMap.map((item) => {
         if (item.id == event.value) {
            setgetselectStatedata(event);
            item.childs && item.childs.length > 0 && item.childs.map((item) => {
              item.label = item.name;
              item.value = item.id;
              myChildArray.push(item);
            })
            setgetselectCitylist(myChildArray);
          }  
      });
   }

   const handleCityChange = (event) => {
      setgetselectCitydata(event);
   }

   const addressApply = () => {

      if (getselectStatedata.value && getselectCitydata.value) {
         let params = {
            state: getselectStatedata.value,
            city: getselectCitydata.value,
         }
         office(formDataGenerator(params));
      }

   };

   const handleReset = () => {
      setgetselectStatedata('');
      setgetselectCitydata('');
      setgetselectCitylist('');
      // setlatitude(18.9295844);
      // setlongitude(72.8262993);
      sethdfcOffice('');
      setcamsOffice('');
   };

   const [writeToModalShow, setWriteToModalShow] = useState(false);
   const handleCloseWrite = () => setWriteToModalShow(false);
   const handleShowWrite = (e) => {
      setWriteToModalShow(true);
   }

   useEffect(() => {
      if (
         currentPageurl === "get-in-touch" &&
         getintouchdata &&
         getintouchdata.meta
      ) {
         setmetaData(getintouchdata && getintouchdata.meta);
      }
      if (
         currentPageurl === "visit-us" &&
         getVisitUsContent &&
         getVisitUsContent.meta
      ) {
         setmetaData(getVisitUsContent && getVisitUsContent.meta);
      }
      if (
         currentPageurl === "investor-relationship-officer" &&
         getInvesterRelationship &&
         getInvesterRelationship.meta
      ) {
         setmetaData(getInvesterRelationship && getInvesterRelationship.meta);
      }
      if (
         currentPageurl === "stakeholders-information-and-helpdesk" &&
         getStakeholderContent &&
         getStakeholderContent.meta
      ) {
         setmetaData(getStakeholderContent && getStakeholderContent.meta);
      }
      if (
         currentPageurl === "chief-information-security-officer" &&
         getChiefContent &&
         getChiefContent.meta
       ) {
         setmetaData(getChiefContent && getChiefContent.meta);
       }
   }, [currentPageurl, getintouchdata, getVisitUsContent, getInvesterRelationship, getStakeholderContent, getChiefContent]);

   useEffect(() => {
      window.scrollTo(0,0);
   },[])

   return (
      <div className="wrapper">
         {current == "get-in-touch" || current == "visit-us" || current == "investor-relationship-officer" || current == "stakeholders-information-and-helpdesk" || current == "chief-information-security-officer"  ? <>
         {metaData ? (
            <Helmet>
               <title>{metaData && metaData.title ? metaData.title : ""}</title>
               <meta
                  name="description"
                  content={
                     metaData && metaData.description ? metaData.description : ""
                  }
               />
               <meta
                  name="keywords"
                  content={metaData && metaData.keywords ? metaData.keywords : ""}
               />
               <meta
                  property="og:title"
                  content={metaData && metaData.og_title ? metaData.og_title : ""}
               />
               <meta
                  property="og:description"
                  content={
                     metaData && metaData.og_description ? metaData.og_description : ""
                  }
               />
               <meta
                  property="og:image"
                  content={metaData && metaData.og_image ? metaData.og_image : ""}
               />
               <meta
                  property="og:url"
                  content={metaData && metaData.og_url ? metaData.og_url : ""}
               />
            </Helmet>
         ) : (
            ""
         )}
         <section className="aboutHead">
            <div className="container">
               <div className="d-flex">
                  <h1 className="me-auto">Contact<span> Us</span> <img className="d-md-none"
                     src="./images/redDownArrow.svg" alt="" /></h1>
                  <nav aria-label="breadcrumb"
                     className="align-items-center d-none d-md-inline">
                     <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                           <a className="bread_blue" href="/">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                           <a className="bread_blue" href="/contact-us">Contact Us</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                           {getHeaderBreadCrump}
                        </li>
                     </ol>
                  </nav>
               </div>
            </div>
         </section>

         <section className="customSlick contactdiv">
            <Tabs className="customTab" selectedIndex={selectedIndex}
               onSelect={tabIndex => setSelectedIndex(tabIndex)}>

               <div className='container'>
                  <TabList>
                     <Tab onClick={(e) => handleApiCall(e, 'get-in-touch')} id="get-in-touch" tabFor="0" value="0">
                        <Link to={getRouting('/contact-us/get-in-touch', 'Get In Touch')}>
                           <div>
                              <h2 className="tabhead">Get In Touch</h2>
                           </div>
                        </Link>
                     </Tab>
                     <Tab onClick={(e) => handleApiCall(e, 'visit-us')} id="visit-us" tabFor="1" value="1">
                        <Link to={getRouting('/contact-us/visit-us', 'Visit Us')}>
                           <div>
                              <h2 className="tabhead">Visit Us</h2>
                           </div>
                        </Link>
                     </Tab>
                     <Tab onClick={(e) => handleApiCall(e, 'investor-relationship-officer')} id="investor-relationship-officer" tabFor="2" value="2">
                        <Link to={getRouting('/contact-us/investor-relationship-officer', 'Investor Relationship Officer')}>
                           <div>
                              <h2 className="tabhead">Investor Relationship Officer</h2>
                           </div>
                        </Link>
                     </Tab>

                     <Tab onClick={(e) => handleApiCall(e, 'stakeholders-information-and-helpdesk')} id="stakeholders-information-and-helpdesk" tabFor="3" value="3">
                        <Link to={getRouting('/contact-us/stakeholders-information-and-helpdesk', 'Stakeholders Information And Helpdesk')}>
                           <div>
                              <h2 className="tabhead">Stakeholder's Information & Helpdesk </h2>
                           </div>
                        </Link>
                     </Tab>
                   
                     <Tab
                        onClick={(e) =>
                           handleApiCall(e, "chief-information-security-officer")
                        }
                        id="chief-information-security-officer"
                        tabFor="4"
                        value="4"
                     >
                        <Link
                           to={getRouting(
                           "/contact-us/chief-information-security-officer",
                           "Chief Information Security Officer"
                           )}
                        >
                           <div>
                           <h2 className="tabhead">Chief Information Security Officer</h2>
                           </div>
                        </Link>
                     </Tab>
                  </TabList>
               </div>

               <TabPanel>
                  {/* {getintouchdata ? <div dangerouslySetInnerHTML={{ __html: getintouchdata }} /> : null} */}
                  <div>
                     <div className="container mb-5">
                        <section>
                           <div className="post mr-5">
                              <div className="">
                                 {getintouchdata && getintouchdata.summary ? <div dangerouslySetInnerHTML={{ __html: getintouchdata.summary }} /> : null}

                                 <p className="mobile_display">Following avenues:</p>

                                 <div>
                                    <div className="row">
                                       {getintouchdata && getintouchdata.content && getintouchdata.content.length > 0 && getintouchdata.content.map((cont, index) => (
                                          <div className="col-md-6 mb-3">
                                             <div className="card w-100 h-100">
                                                <div className="card-body">
                                                   <div className="post_box"><img alt="..." className="svgContactUs" src={cont.iconUrl} />
                                                      {index === 0 ? <p className="writeToUsCurserPointer"><a className="color_blue" onClick={(e) => handleShowWrite(e)} >{cont.title}</a></p> : <p className="color_blue">{cont.title} </p>}

                                                   </div>

                                                   {cont && cont.details ? <div dangerouslySetInnerHTML={{ __html: cont.details }} /> : null}

                                                </div>
                                             </div>
                                          </div>
                                       ))}
                                       {getintouchdata && getintouchdata.description ? <div dangerouslySetInnerHTML={{ __html: getintouchdata.description }} /> : null}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>

               </TabPanel>

               <TabPanel>
                  <div>
                     <div className="container mb-5">
                        <section>
                           <div className="visit_us">
                              <div className="">
                                 <div className="row pb-0">
                                    <div className="col-lg-8">
                                       <div className="row">
                                          <div className="col-6">
                                             <p className='pb-3 visitFont'>Select State</p>
                                             <Select
                                                placeholder="Please select"
                                                value={getselectStatedata}
                                                onChange={handleChange}
                                                options={getselectStatelist}
                                                className="searchselect"
                                             />
                                          </div>
                                          <div className="col-6">
                                             <p className='pb-3 visitFont'>Select city</p>
                                             <Select
                                                placeholder="Please select"
                                                value={getselectCitydata}
                                                onChange={handleCityChange}
                                                options={getselectCitylist}
                                                className="searchselect"
                                             />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-lg-4 pt-md-5 btn_reset">
                                       <div className='row pb-0'>
                                          <div className="col-md-6 d-md-flex justify-content-end applyBtn">
                                             <button type="submit" className="btn btn-primary px-5" onClick={addressApply}>Apply</button>
                                          </div>
                                          <div className="col-md-6 d-md-flex applyBtn">

                                             <button type="reset" className="btn btn-outline-primary px-5" id="resetContact" onClick={handleReset}>Reset</button>
                                          </div>
                                       </div>

                                    </div>
                                 </div>
                                 {/* <iframe src={`https://maps.google.com/maps?q=${latitude},${longitude}&hl=es;z=14&output=embed`}
                                    width="100%" height="614px" style={{ border: "0", borderRadius: "10px" }} allowfullscreen="" loading="lazy" frameborder="0">
                                 </iframe> */}

                                 {(hdfcOffice || camsOffice) ? <div className="mobile_tab_contact mt-4">
                                    <Tabs>
                                       <TabList>
                                          <Tab>
                                             <div className="btn w-100">
                                                Our Office
                                             </div>
                                          </Tab>
                                          <Tab>
                                             <div className="btn w-100">
                                                CAMS Location
                                             </div>
                                          </Tab>
                                       </TabList>

                                       <TabPanel>
                                          {hdfcOffice ? hdfcOffice && Object.keys(hdfcOffice).map((locationType) => {

                                             let loc = hdfcOffice[locationType];

                                             return loc && loc.locations && loc.locations.map((item) => {
                                                return (
                                                   <div>
                                                      <p className="asset mt-4">{item.address_1 ? item.address_1 : ''}</p>
                                                      {item.address_2 ? <p className="addressAmc">{item.address_2}</p> : ''}
                                                      {item.address_3 ? <p className="addressAmc">{item.address_3}</p> : ''}
                                                      {item.city && item.pin ? <p className="addressAmc">{item.city}-  {item.pin} </p> : ''}
                                                      {item.state ? <p className="addressAmc">{item.state} </p> : ''}

                                                      <div className="d-flex my-2">
                                                         <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/call-us.svg"
                                                            alt="call-us-icon"
                                                         />
                                                         <div className="tell text-break">Tel :&nbsp;
                                                         {item.contact_no ? 
                                                            <a href={`tel:${item.contact_no ? item.contact_no : ""}`}>
                                                               {item.contact_no ? item.contact_no : "N/A"}
                                                            </a>
                                                         : 'N/A'}&nbsp;/&nbsp;

                                                         {
                                                            item.contact_no1 ?
                                                            <a href={`tel:${item.contact_no1 ? item.contact_no1 : ""}`}>
                                                               {item.contact_no1 ? item.contact_no1 : "N/A"}
                                                            </a>
                                                            : "N/A" 
                                                         }
                                                         </div>
                                                      </div>

                                                      {/* <div className="d-flex">
                                                         <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/email-at.svg" className="img-fluid" />
                                                         <p className="tell text-break">Email : {item.email ? item.email : 'N/A'}</p>
                                                      </div> */}
                                                   </div>
                                                )
                                             })

                                          }) : 'NA'}
                                       </TabPanel>
                                       <TabPanel>
                                          {camsOffice ? camsOffice && Object.keys(camsOffice).map((locationType) => {

                                             let loc = camsOffice[locationType];

                                             return loc && loc.locations && loc.locations.map((item) => {
                                                return (<div>
                                                   <p className="asset mt-4">{item.address_1 ? item.address_1 : ''}</p>
                                                   {item.address_2 ? <p className="addressAmc">{item.address_2}</p> : ''}
                                                   {item.address_3 ? <p className="addressAmc">{item.address_3}</p> : ''}
                                                   {item.city && item.pin ? <p className="addressAmc">{item.city}-  {item.pin} </p> : ''}
                                                   {item.state ? <p className="addressAmc">{item.state} </p> : ''}

                                                   <div className="d-flex">
                                                      <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/call-us.svg"
                                                         alt="call-us-icon"
                                                      />
                                                      <div className="tell text-break">Tel :&nbsp;
                                                      {item.contact_no ? 
                                                         <a href={`tel:${item.contact_no ? item.contact_no : ""}`}>
                                                            {item.contact_no ? item.contact_no : "N/A"}
                                                         </a>
                                                      : 'N/A'}&nbsp;/&nbsp;

                                                      {
                                                         item.contact_no1 ?
                                                         <a href={`tel:${item.contact_no1 ? item.contact_no1 : ""}`}>
                                                            {item.contact_no1 ? item.contact_no1 : "N/A"}
                                                         </a>
                                                         : "N/A"
                                                      }
                                                      </div>
                                                   </div>
                                                   {/* <div className="d-flex">
                                                      <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/email-at.svg" className="img-fluid" />
                                                      <p className="tell text-break">Email : {item.email ? item.email : 'N/A'}</p>
                                                   </div> */}
                                                </div>
                                                )
                                             })

                                          }) : 'NA'}
                                       </TabPanel>
                                    </Tabs>


                                 </div> : ''}

                                 <div className="mobile_tab_contact mt-4">

                                    <Tabs>
                                       <TabList>
                                          <Tab>
                                             <div className="btn w-100">
                                                Head Office
                                             </div>
                                          </Tab>
                                          <Tab>
                                             <div className="btn w-100">
                                                Overseas Office
                                             </div>
                                          </Tab>
                                       </TabList>

                                       <TabPanel>
                                          {getvisitUsdata && getvisitUsdata.head_office && getvisitUsdata.head_office[0] && getvisitUsdata.head_office[0].office_address ? <div dangerouslySetInnerHTML={{ __html: getvisitUsdata.head_office[0].office_address }} /> : null}
                                       </TabPanel>
                                       <TabPanel>
                                          {getvisitUsdata && getvisitUsdata.overseas_office && getvisitUsdata.overseas_office[0] && getvisitUsdata.overseas_office[0].office_address ? <div dangerouslySetInnerHTML={{ __html: getvisitUsdata.overseas_office[0].office_address }} /> : null}
                                       </TabPanel>
                                    </Tabs>


                                 </div>

                                 <div className="card-group mobile_tab_contact1 row">

                                    {hdfcOffice && Object.keys(hdfcOffice).map((locationType) => {

                                       let loc = hdfcOffice[locationType];

                                       return loc && loc.locations && loc.locations.map((item) => {
                                          return (
                                             <div className='col-md-6'>
                                                <div className="card">
                                                   <div className="card-header">Our Office</div>
                                                   <div className="card-body">
                                                      <p className="asset">{item.address_1 ? item.address_1 : ''}</p>

                                                      {item.address_2 ? <p className="addressAmc">{item.address_2}</p> : ''}
                                                      {item.address_3 ? <p className="addressAmc">{item.address_3}</p> : ''}
                                                      {item.city && item.pin ? <p className="addressAmc">{item.city}-  {item.pin} </p> : ''}
                                                      {item.state ? <p className="addressAmc">{item.state} </p> : ''}

                                                      <div className="d-flex my-2">
                                                         <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/call-us.svg"
                                                            alt="call-us-icon"
                                                         />
                                                         <div className="tell">Tel : &nbsp;
                                                         {item.contact_no ? 
                                                            <a href={`tel:${item.contact_no ?item.contact_no : ""}`}>
                                                               {item.contact_no ?item.contact_no : "N/A"}
                                                            </a>
                                                         : 'N/A'}&nbsp;/&nbsp;

                                                         {
                                                            item.contact_no1 ? 
                                                            <a href={`tel:${item.contact_no1 ? item.contact_no1 : ""}`}>
                                                               {item.contact_no1 ? item.contact_no1 : "N/A"}
                                                            </a>
                                                            : "N/A"
                                                         }
                                                         </div>
                                                      </div>

                                                      {/* <div className="d-flex">
                                                         <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/email-at.svg" className="img-fluid" />
                                                         <p className="tell">Email : {item.email ? item.email : 'N/A'}</p>
                                                      </div> */}
                                                   </div>
                                                </div>
                                             </div>
                                          )
                                       })

                                    })}

                                    {camsOffice && Object.keys(camsOffice).map((locationType) => {

                                       let loc = camsOffice[locationType];

                                       return loc && loc.locations && loc.locations.map((item) => {
                                          return (
                                             <div className='col-md-6'>
                                                <div className="card">
                                                   <div className="card-header">CAMS Location</div>
                                                   <div className="card-body">
                                                      <p className="asset">{item.address_1 ? item.address_1 : ''}</p>

                                                      {item.address_2 ? <p className="addressAmc">{item.address_2}</p> : ''}
                                                      {item.address_3 ? <p className="addressAmc">{item.address_3}</p> : ''}
                                                      {item.city && item.pin ? <p className="addressAmc">{item.city}-  {item.pin} </p> : ''}
                                                      {item.state ? <p className="addressAmc">{item.state} </p> : ''}

                                                      <div className="d-flex my-2">
                                                         <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/call-us.svg"
                                                            alt="call-us-icon"
                                                         />
                                                         <div className="tell">Tel : &nbsp;
                                                         {item.contact_no ? 
                                                            <a href={`tel:${item.contact_no ? item.contact_no : ""}`}>
                                                            {item.contact_no ? item.contact_no : "N/A"}
                                                            </a>
                                                         : 'N/A'}&nbsp;/&nbsp;

                                                         {
                                                            item.contact_no1 ?
                                                            <a href={`tel:${item.contact_no1 ? item.contact_no1 : ""}`}>
                                                               {item.contact_no1 ? item.contact_no1 : "N/A"}
                                                            </a>
                                                            : "N/A"
                                                         }
                                                         </div>
                                                      </div>
                                                      {/* <div className="d-flex">
                                                         <img src="https://hdfcmf-website-uat.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/email-at.svg" className="img-fluid" />
                                                         <p className="tell">Email : {item.email ? item.email : 'N/A'}</p>
                                                      </div> */}
                                                   </div>
                                                </div>
                                             </div>
                                          )
                                       })

                                    })}

                                 </div>

                                 <div className="card-group mobile_tab_contact1 row">
                                    <div className='col-md-6'>
                                       <div className="card">
                                          <div className="card-header">Head Office</div>
                                          <div className="card-body">
                                             {getvisitUsdata && getvisitUsdata.head_office && getvisitUsdata.head_office[0] && getvisitUsdata.head_office[0].office_address ? <div dangerouslySetInnerHTML={{ __html: getvisitUsdata.head_office[0].office_address }} /> : null}
                                          </div>
                                       </div>
                                    </div>
                                    <div className='col-md-6'>
                                       <div className="card">
                                          <div className="card-header">Overseas Office</div>
                                          <div className="card-body">
                                             {getvisitUsdata && getvisitUsdata.overseas_office && getvisitUsdata.overseas_office[0] && getvisitUsdata.overseas_office[0].office_address ? <div dangerouslySetInnerHTML={{ __html: getvisitUsdata.overseas_office[0].office_address }} /> : null}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 {getvisitUsdata && getvisitUsdata.visitUs ? <div dangerouslySetInnerHTML={{ __html: getvisitUsdata.visitUs }} /> : null}
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </TabPanel>

               <TabPanel>
                  <div>
                     <div className="container  mb-5">
                        <section>
                           <div className=''>
                              <div className="mf-cards invcesterDesktop">
                                 <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab"
                                       data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home"
                                       aria-selected="true">Home</button>
                                    <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab"
                                       data-bs-target="#nav-profile" type="button" role="tab"
                                       aria-controls="nav-profile" aria-selected="false">Profile</button>
                                 </div>

                                 <h3 className="my-4 pt-4">Investor Relations Officer</h3>
                                 <div className="row ">

                                    <div className="col-md-6 d-md-flex align-items-stretch">
                                       <div className=" grievance-card  mb-4 mb-md-0">
                                          {getrelationdata && getrelationdata.mutual_fund && getrelationdata.mutual_fund[0] && getrelationdata.mutual_fund[0].details ? <div dangerouslySetInnerHTML={{ __html: getrelationdata.mutual_fund[0].details }} /> : null}

                                       </div>
                                    </div>
                                    <div className="col-md-6 d-md-flex align-items-stretch">
                                       <div className=" grievance-card mb-4 mb-md-0 ">
                                          {getrelationdata && getrelationdata.pms && getrelationdata.pms[0] && getrelationdata.pms[0].details ? <div dangerouslySetInnerHTML={{ __html: getrelationdata.pms[0].details }} /> : null}
                                       </div>
                                    </div>
                                 </div>
                              </div>

                              <div className="mobile_tab_contact mt-4">

                                 <Tabs>
                                    <TabList>
                                       <Tab>
                                          <div className="btn w-100">
                                             Mutual Fund
                                          </div>
                                       </Tab>
                                       <Tab>
                                          <div className="btn w-100">
                                             PMS
                                          </div>
                                       </Tab>
                                    </TabList>

                                    <TabPanel>
                                       <div className=" grievance-card  mb-4 mb-md-0">
                                          {getrelationdata && getrelationdata.mutual_fund && getrelationdata.mutual_fund[0] && getrelationdata.mutual_fund[0].details ? <div dangerouslySetInnerHTML={{ __html: getrelationdata.mutual_fund[0].details }} /> : null}
                                       </div>
                                    </TabPanel>
                                    <TabPanel>
                                       <div className=" grievance-card mb-4 mb-md-0 ">
                                          {getrelationdata && getrelationdata.pms && getrelationdata.pms[0] && getrelationdata.pms[0].details ? <div dangerouslySetInnerHTML={{ __html: getrelationdata.pms[0].details }} /> : null}
                                       </div>
                                    </TabPanel>
                                 </Tabs>


                              </div>

                              {getrelationdata && getrelationdata.grievance_officer ? <div dangerouslySetInnerHTML={{ __html: getrelationdata.grievance_officer }} /> : null}
                           </div>

                        </section>
                     </div>
                  </div>
               </TabPanel>

               <TabPanel>
                  {getstakeholderdata ? <div dangerouslySetInnerHTML={{ __html: getstakeholderdata }} /> : null}
               </TabPanel>

               <TabPanel>
                  {getchiefdata ? (
                  <div dangerouslySetInnerHTML={{ __html: getchiefdata }} />
                  ) : null}
               </TabPanel>

            </Tabs>
         </section>

         <WriteToModal open={writeToModalShow} onClose={handleCloseWrite} /></>:<PageNotFound/>}
      </div>

   )
}
const mapStateToProps = (state) => ({
   getInTouchContent: state.contactUs.getInTouch,
   getVisitUsContent: state.contactUs.visitUs,
   getInvesterRelationship: state.contactUs.relationshipOfficer,
   getStakeholderContent: state.contactUs.stakeHolderInformation,
   getChiefContent: state.contactUs.chiefInformation,
   getFilterListCOntent: state.contactUs.offices.filterList,
   officeAddress: state.contactUs.office
});

const mapDispatchToProps = (dispatch) => ({
   getContactUsContent: bindActionCreators(getContactUsContent, dispatch),
   getChiefInformation : bindActionCreators(getChiefInformation, dispatch),
   getOfficesFilterList: bindActionCreators(getOfficesFilterList, dispatch),
   office: bindActionCreators(office, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);